<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">申请时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="area" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in areaList" :key="index" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">用户名</span>
        <el-input v-model.trim="phone" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">实物名称</span>
        <el-input v-model.trim="phone" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary">
          搜索
        </el-button>
        <el-button type="primary">
          抵扣协议
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="" label="用户名"></el-table-column>
      <el-table-column align="center" prop="" label="实物名称"></el-table-column>
      <el-table-column align="center" prop="" label="抵扣金额"></el-table-column>
      <el-table-column align="center" prop="" label="数量"></el-table-column>
      <el-table-column align="center" prop="" label="申请时间"></el-table-column>
      <el-table-column align="center" prop="" label="状态"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a">审核</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    name: 'WalletList',
    data () {
      return {
        date: '',
        phone: '',
        area: '',
        areaList: [],
        status: '1',
        tableData: [{1: 1}, {1: 1}, {1: 1}, {1: 1},],
        tableLoading: false,
      }
    },
    methods: {}
  }
</script>

<style scoped>

</style>
